import {
  Box,
  Flex,
  Heading,
  Stack,
  Text,
  TabPanels,
  Tab,
  TabList,
  Tabs,
} from "@chakra-ui/react";
import React from "react";
import CommonContainer from "../../components/shared/CommonContainer";
import AnalyticsCards from "../../components/freelancer/analytics/AnalyticsCards";
import AnalyticsOverview from "../../components/freelancer/analytics/Overview";
import Goals from "../../components/freelancer/analytics/Goals";
import SellerLevel from "../../components/freelancer/analytics/SellerLevel";
import Ratings from "../../components/freelancer/analytics/Ratings";
import WorldDomination from "../../components/freelancer/analytics/WorldDomination";

export default function FreelancerAnalyticsPage() {
  const [tab, setTab] = React.useState("Overview");
  return (
    <CommonContainer>
      <Stack my={{ base: 10, xl: 20 }}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "21px", md: "26px" }}
          pb={10}
          display={{ base: "none", xl: "block" }}
        >
          Analytics
        </Heading>
        <Flex
          justifyContent="space-between"
          alignItems="start"
          mb={10}
          flexDir={{ base: "column", lg: "row" }}
        >
          <Box
            fontSize={{ base: "14px", lg: "21px" }}
            w={{ xl: "250px" }}
            pr={3}
            fontWeight="medium"
            display={{ base: "none", xl: "block" }}
          >
            {linksData.map((item, index) => {
              return (
                <Text
                  mb={3}
                  color={item.label === tab ? "brand.500" : "#c5c5c5"}
                  cursor="pointer"
                  key={index}
                  onClick={()=>{setTab(item.label);}}
                >
                  {item.label}
                </Text>
              );
            })}
          </Box>
          <Box
            px={{ md: 5, lg: 10, xl: 20 }}
            fontSize={{ md: "19px" }}
            w={{ xl: "90%" }}
            borderLeft={{ xl: "1px" }}
            borderColor="#707070"
            display={{ base: "none", xl: "block" }}
          >
            <Flex
              justifyContent={"space-between"}
              flexDir={{ base: "column", "2xl": "row" }}
              gap={10}
            >
              <Box w={{ "2xl": "20%" }}>
                <AnalyticsCards />
              </Box>
              <Box w={{ "2xl": "80%" }} h="100%">
                <AnalyticsOverview />
              </Box>
            </Flex>
            <Goals />
            <SellerLevel />
            <Flex
              my={10}
              gap={10}
              flexDirection={{ base: "column", "2xl": "row" }}
            >
              <Box w={{ "2xl": "40%" }}>
                <Ratings />
              </Box>
              <Box w={{ "2xl": "60%" }}>
                <WorldDomination />
              </Box>
            </Flex>
          </Box>
          <Tabs
            variant=""
            isFitted
            w="full"
            display={{ base: "block", xl: "none" }}
          >
            <TabList overflow="auto" w="full">
              {linksData.map((item) => {
                return (
                  <Tab
                    _selected={{ color: "white", bg: "brand.500" }}
                    bg="#f4f4f4"
                    onClick={() => {
                      setTab(item.label);
                    }}
                    key={item.label}
                  >
                    {item.label}
                  </Tab>
                );
              })}
            </TabList>
            <TabPanels>
              <Flex
                justifyContent={"center"}
                flexDir={{ base: "column", "2xl": "row" }}
                gap={10}
                py={6}
              >
                <Box w={{ "2xl": "20%" }}>
                  <AnalyticsCards />
                </Box>
                <Box w={{ "2xl": "80%" }} h="100%">
                  <AnalyticsOverview />
                </Box>
              </Flex>
              <Goals />
              <SellerLevel />
              <Flex
                my={10}
                gap={10}
                flexDirection={{ base: "column", xl: "row" }}
              >
                <Box w={{ xl: "40%" }}>
                  <Ratings />
                </Box>
                <Box w={{ xl: "60%" }}>
                  <WorldDomination />
                </Box>
              </Flex>
            </TabPanels>
          </Tabs>
        </Flex>
      </Stack>
    </CommonContainer>
  );
}
const linksData = [
  {
    label: "Overview",
    path: "",
  },
  {
    label: "Repeat Business",
    path: "",
  },
];
